// extracted by mini-css-extract-plugin
export default {"imagesCarousel":"image-carousel_imagesCarousel__tKT8K","imageItem":"image-carousel_imageItem__yA-kG","selected":"image-carousel_selected__r3CK-"};